import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@/store/store";
import { setIseditAppointment, setIsVisibleModalDialog } from "@/store/ui/ui";
import AnimatedInputSumButton from "./AnimatedInputSumButton";
import priceFormatter from "@/utils/priceFormatter";
import { ISearchDrawerProps } from "@/shared/interfaces/ui";
import { totalPriceCounter } from "@/services/API/totalPriceCounter";
import useGetRole from "@/hooks/useGetRole";

import getArraySum from "@/utils/getArraySum";
import Button from "@/shared/components/Button/Button";
import Title from "@/shared/components/Title/Title";
import { toast } from "react-toastify";
import { adminMessage } from "@/utils/constants";

export default function ScheduleAppointmentTotal({
    toggleDrawer,
}: ISearchDrawerProps) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isAdmin } = useGetRole();

    const appointmentInfo = useSelector(
        (state: RootState) => state.appointments.existtAppointment,
    );

    const { services, _id, paymentHistory } = appointmentInfo;
    const total = totalPriceCounter(services);
    const payments = getArraySum(paymentHistory || []);

    function deleteAppointment() {
        const isComplete = appointmentInfo?.isAppointmentComplete ?? false;

        if (isAdmin) {
            if (!isComplete) {
                toggleDrawer(false);
                dispatch(setIsVisibleModalDialog(true));
            } else {
                toast.error(
                    "Візит завершений і сплачений. Візит не може бути видалений!",
                );
            }
        } else {
            toast.error(adminMessage);
        }
    }

    return (
        <div className='drawer_total'>
            <Title
                tag='h2'
                text={"Всього"}
                span={priceFormatter(total)}
                style={{ marginBottom: 4 }}
            />
            <Title
                tag='h3'
                text={"Cплачено"}
                span={
                    paymentHistory?.length > 0
                        ? priceFormatter(payments)
                        : "0.00"
                }
                style={{ color: "#47586E" }}
            />
            <Title
                tag='h3'
                text={"Борг"}
                span={priceFormatter(total - payments)}
                style={{ color: "#AD1313" }}
            />
            <AnimatedInputSumButton toggleDrawer={toggleDrawer} />
            <div className='drawer_total_button_container'>
                <Button
                    text={"Редагувати"}
                    variant='edit-small'
                    onClick={() => {
                        dispatch(setIseditAppointment(true));
                        navigate("/appointments");
                    }}
                />
                <Button
                    id={_id}
                    text={"Видалити"}
                    variant='delete-small'
                    onClick={deleteAppointment}
                />
            </div>
        </div>
    );
}
